// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WiHl","icon":"styles_icon__3RMLo"};